import React, { cloneElement } from "react";
import { UsersIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

interface EmptyStateProps {
  message?: string;
  icon?: React.ReactNode;
  height?: string;
  className?: string;
}

const DEFAULT_HEIGHT = "209px";

export const EmptyStateComponent = ({
  message,
  icon,
  height = DEFAULT_HEIGHT,
  className,
}: EmptyStateProps) => {
  const { t } = useTranslation();

  const defaultIcon = <UsersIcon className="size-12" />;
  const sizedIcon = icon
    ? cloneElement(icon as React.ReactElement<{ className?: string }>, {
        className: "size-12",
      })
    : defaultIcon;

  return (
    <div
      className={cn("flex flex-col items-center justify-center", className)}
      style={{ height }}
      role="status"
      aria-live="polite"
    >
      <div className="h-12 w-12 text-muted-foreground">{sizedIcon}</div>
      <div className="mt-8 text-sm text-muted-foreground">
        {message || t("emptyState.noStudents", "No Students Found.")}
      </div>
    </div>
  );
};
